export default "__VITE_ASSET__3d9c9f85__"